// Modules
import React from "react";

let year = new Date().getFullYear();

interface Props {
    //TODO: set proper TS
    links: any
}

interface Link {
    id: string,
    url: string,
    linkCopy: string
}

const FooterLinks = (props: Props) => {
    return (
        <div className="yCmsComponent">
            {props.links.footerLinks &&
            <div className="links">
                {props.links.footerLinks.map((link: Link) => {
                    return <a key={link.id}>{link.linkCopy}</a>
                })}
            </div>
            }
            <div className="copyright">
                {/* This needs to come from endpoint object including the date. As is here for display purposes. */}
                <p> &copy; Copyright {year}, Marriott Vacation Club International, All rights reserved. </p>
            </div>
        </div>
    )
}

export default FooterLinks;
